// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".companyInfo_root__3CdHU {\n  width: 100%;\n  position: relative; }\n\n.companyInfo_error__7illP {\n  color: red; }\n  .companyInfo_error__7illP.companyInfo_hidden__3TyyJ {\n    display: none; }\n\n.companyInfo_loading__368ke {\n  position: absolute;\n  top: calc(50% - 20px);\n  left: calc(50% - 20px); }\n", ""]);
// Exports
exports.locals = {
	"root": "companyInfo_root__3CdHU",
	"error": "companyInfo_error__7illP",
	"hidden": "companyInfo_hidden__3TyyJ",
	"loading": "companyInfo_loading__368ke"
};
module.exports = exports;
